export default "__VITE_ASSET__CKHPNr2C__"